






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Popup from "@/components/Popup/Popup.vue";
import NavBar from "@/components/NavBar/NavBar.vue";
import EarnUserList from "./insUser/EarnUserList.vue";
import AddAcount from "./insUser/AddAcount.vue";
import { goToLogin } from "@/utils/router_helper";
@Component({
  components: { Popup, NavBar, EarnUserList, AddAcount }
})
export default class InsUserGallery extends Vue {
  @Prop({ default: false })
  private value?: boolean;
  @Prop({ default: "" })
  private currentEarnCoinsUserId!: string;

  private popShow = false;

  @Watch("value", { immediate: true })
  private changePop(val: boolean, oldVal: boolean) {
    this.popShow = val;
  }
  @Watch("popShow", { immediate: true })
  private change(val: boolean, oldVal: boolean) {
    this.$emit("input", val);
  }

  private clolsePopup() {
    this.$emit("input", false);
  }

  private clickItem(val: string) {
    this.$emit("userChange", val);
    this.clolsePopup();
  }

  private clickSearch() {
    goToLogin();
    this.clolsePopup();
  }
}
